export const MESSAGE_NOTIFY = 'MESSAGE_NOTIFY';
export const MESSAGE_NOTIFY_HIDE = 'MESSAGE_NOTIFY_HIDE';

export function notify(message: string) {
  return {
    type: MESSAGE_NOTIFY,
    message
  }
}

export function hideMessage(id: string) {
  return {
    type: MESSAGE_NOTIFY_HIDE,
    id
  }
}



// WEBPACK FOOTER //
// ./src/actions/message.ts